module.exports = __webpack_public_path__ + "img/5-3.80111b10.png";